export const languageMap = [
  'abap',
  'actionscript-3',
  'ada',
  'apache',
  'apex',
  'apl',
  'applescript',
  'ara',
  'asm',
  'astro',
  'awk',
  'ballerina',
  'bat',
  'beancount',
  'berry',
  'bibtex',
  'bicep',
  'blade',
  'c',
  'cadence',
  'clarity',
  'clojure',
  'cmake',
  'cobol',
  'codeql',
  'coffee',
  'cpp',
  'crystal',
  'csharp',
  'css',
  'cue',
  'cypher',
  'd',
  'dart',
  'dax',
  'diff',
  'docker',
  'dream-maker',
  'elixir',
  'elm',
  'erb',
  'erlang',
  'fish',
  'fsharp',
  'gdresource',
  'gdscript',
  'gdshader',
  'gherkin',
  'git-commit',
  'git-rebase',
  'glimmer-js',
  'glimmer-ts',
  'glsl',
  'gnuplot',
  'go',
  'graphql',
  'groovy',
  'hack',
  'haml',
  'handlebars',
  'haskell',
  'hcl',
  'hjson',
  'hlsl',
  'html',
  'http',
  'imba',
  'ini',
  'java',
  'javascript',
  'jinja-html',
  'jison',
  'json',
  'json5',
  'jsonc',
  'jsonl',
  'jsonnet',
  'jssm',
  'jsx',
  'julia',
  'kotlin',
  'kusto',
  'latex',
  'less',
  'liquid',
  'lisp',
  'logo',
  'lua',
  'make',
  'markdown',
  'marko',
  'matlab',
  'mdc',
  'mdx',
  'mermaid',
  'mojo',
  'narrat',
  'nextflow',
  'nginx',
  'nim',
  'nix',
  'objective-c',
  'objective-cpp',
  'ocaml',
  'pascal',
  'perl',
  'php',
  'plsql',
  'postcss',
  'powerquery',
  'powershell',
  'prisma',
  'prolog',
  'proto',
  'pug',
  'puppet',
  'purescript',
  'python',
  'r',
  'raku',
  'razor',
  'reg',
  'rel',
  'riscv',
  'rst',
  'ruby',
  'rust',
  'sas',
  'sass',
  'scala',
  'scheme',
  'scss',
  'shaderlab',
  'shellscript',
  'shellsession',
  'smalltalk',
  'solidity',
  'sparql',
  'splunk',
  'sql',
  'ssh-config',
  'stata',
  'stylus',
  'svelte',
  'swift',
  'system-verilog',
  'tasl',
  'tcl',
  'tex',
  'toml',
  'tsx',
  'turtle',
  'twig',
  'typescript',
  'v',
  'vb',
  'verilog',
  'vhdl',
  'viml',
  'vue',
  'vue-html',
  'vyper',
  'wasm',
  'wenyan',
  'wgsl',
  'wolfram',
  'xml',
  'xsl',
  'yaml',
  'zenscript',
  'zig',
  'bash',
  'batch',
  'be',
  'c#',
  'cdc',
  'clj',
  'cmd',
  'console',
  'cql',
  'cs',
  'dockerfile',
  'erl',
  'f#',
  'fs',
  'fsl',
  'gjs',
  'gts',
  'hbs',
  'hs',
  'jade',
  'js',
  'kql',
  'makefile',
  'md',
  'nar',
  'nf',
  'objc',
  'perl6',
  'properties',
  'ps',
  'ps1',
  'py',
  'ql',
  'rb',
  'rs',
  'sh',
  'shader',
  'shell',
  'shellsession',
  'spl',
  'styl',
  'ts',
  'vim',
  'vimscript',
  'vy',
  'yml',
  'zsh',
  '文言',
];
